import * as React from "react";
import classNames from "classnames";

type Props = {
  children: React.ReactNode;
  className?: string;
};

export default class Header extends React.PureComponent<Props> {
  render() {
    return (
      <h2
        className={classNames(
          "bg-silver semi-bold m-0 px-4 py-2 text-sm leading-normal",
          this.props.className,
        )}
      >
        {this.props.children}
      </h2>
    );
  }
}
